<script>import { twMerge } from "tailwind-merge";
import Icon from "./icon.svelte";
let className = void 0;
export { className as class };
export let as = "button";
export let iconLeft = void 0;
export let iconRight = void 0;
</script>

<svelte:element
  this={as}
  role="button"
  tabindex={0}
  on:click
  on:mouseenter
  on:mouseleave
  on:keydown
  on:keyup
  on:keypress
  on:focus
  on:blur
  class={twMerge(
    'inline-flex items-center gap-2 rounded-xs outline-none transition-opacity hover:opacity-80 focus-visible:ring-4 active:opacity-70',
    className
  )}
  {...$$restProps}
>
  {#if iconLeft}<Icon icon={iconLeft} />{/if}
  <span><slot /></span>
  {#if iconRight}<Icon icon={iconRight} />{/if}
</svelte:element>
